import Urls from '../../../definitions/Urls';
import Api from '../../../api/Api';

const createActionName = require('../../util').createActionName('services/gti');

export const SHOW_GTI_BEGIN_MODAL = createActionName('SHOW_GTI_BEGIN_MODAL');
export const HIDE_GTI_BEGIN_MODAL = createActionName('HIDE_GTI_BEGIN_MODAL');
export const SHOW_GTI_INTERGRATION = createActionName('SHOW_GTI_INTEGRATION');
export const RECEIVE_GTI_TOKEN = createActionName('RECEIVE_GTI_TOKEN');
export const DISMISS_GTI_NOTIFICATION = createActionName(
  'DISMISS_GTI_NOTIFICATION'
);

export const showGtiBeginModal = () => ({
  type: SHOW_GTI_BEGIN_MODAL,
});

export const hideGtiBeginModal = () => ({
  type: HIDE_GTI_BEGIN_MODAL,
});

export const showGtiIntegration = (status) => ({
  type: SHOW_GTI_INTERGRATION,
  payload: status,
});

export const receiveGtiToken = (data) => ({
  type: RECEIVE_GTI_TOKEN,
  payload: data,
});

export const dismissGtiNotification = () => ({
  type: DISMISS_GTI_NOTIFICATION,
});

export const goToGTI = () => (dispatch, getState) => {
  dispatch(hideGtiBeginModal());
  window.open(
    `${Urls.gtiTargetUrl()}/?HTTP_AUTH_ID=${
      getState().services.gti.token
    }&schema=true`
  );
};

export const showGTI = (closestUpcomingGtiAppointment) => (dispatch) => {
  dispatch(showGtiIntegration(closestUpcomingGtiAppointment));
  Api.gtiredirect()
    .then((data) => {
      dispatch(receiveGtiToken(data));
    })
    .catch((err) => {
      console.log(err);
    });
};
